import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  networkCardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'start',
    // height:"35vh"
  },
  cardHolder: {
    boxShadow: 'none !important',
    width: '100% !important',
    [theme.breakpoints.down('md')]: {
      marginTop: '50px',
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '0px !important',
    },
  },
    requestFlex: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '0.5px solid #373A45'
    },
        RCtypo: {
      fontSize: '16px !important',
      fontWeight: '500 !important',
      color: '#373A45',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '11px !important',
      },
    },
  networkCard: {
    borderRadius: '9px !important',
    textAlign: 'start',
    width: '100%',
    cursor: 'pointer',
    padding: '10px 10px 10px 10px',
    backgroundColor: '#F6F8FB',
    '@media (min-width: 1440px) and (max-width: 1460px)': {
      padding: '15.75px 18.25px 15.75px 6px !important',

    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      padding: '21px 12px 21px 8px !important',
    },
  },
  cardImage: {
    borderRadius: '50%',
    marginTop: '30px',
    height: '100px',
    width: '100px',
  },
  cardHeader: {
    color: theme.palette.KenColors.ClientBlack2,
    fontSize: '12px !important',
    fontWeight: '500 !important',
    textTransform: 'capitalize',
    marginLeft: '10px !important',
    marginTop: '5px !important',
    [theme.breakpoints.up('xxl')]: {
      fontSize: '15px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      fontSize: '20px !important',
    },
  },
  cardActionContainer: {
    display: 'flex',
    alignItems: 'start',
    gap: '0px',
    margin: '8px auto',
  },
  cardActionContainerTypo: {
    color: '#585A64',
    fontSize: '14px !important',
    fontWeight: '400 !important',
    marginLeft: '10px !important',
    marginTop: '3px !important',
    [theme.breakpoints.up('xxl')]: {
      fontSize: '14px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '13px !important',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      fontSize: '16px !important',
    },
  },
  cardActionContainerImg: {
    height: '18px !important',
    width: '18px !important',
    textAlign: 'center',
  },

  paperCustom: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    textAlign: 'start',
    padding: '24px',
    borderRadius: '8px !important',
    width: '100%',
  },
  eventBanner: {
    height: '151px !important',
    width: '151px !important',
    borderRadius: '50% !important',
    objectFit: 'cover',
    '@media (min-width: 1240px) and (max-width: 1440px)': {
      height: '125px !important',
      width: '125px !important',
    },
  },
  cardDesign: {
    marginLeft: "10px",
    borderRight: "1px solid #D1D4DB",
    paddingLeft: "10px",
    paddingRight: "10%",
    '@media (min-width: 1440px) and (max-width: 1540px)': {
      paddingRight: "0px",
      marginLeft: "0px",
    },
  },
  eventBannerHead: {
    color: theme.palette.KenColors.ClientBlack2,
    fontSize: '24px !important',
    fontWeight: '600 !important',
    position: 'absolute',
    margin: '10px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '18px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px !important',
    },
  },
  eventDetailsContainer: {
    height: 'auto',
    overflow: 'auto',
    padding: '0px 6px 0px 0px',
    fontSize: '16px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
    },
  },

  eventDetailsHeadingSubContainer: {
    fontSize: '14px !important',
    marginTop: '10px !important',
    marginBottom: '20px !important',
  },
  eventDetailsHeadingTypo: {
    fontSize: '14px !important',
    marginBottom: '2px !important',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.ClientGrey,
    lineHeight: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '9.5px',
    },
    '@media (min-width: 1440px) and (max-width: 1460px)': {
      fontSize: '10.5px !important',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      fontSize: '14px !important',
    },
  },
  eventDetailsTypo: {
    color: theme.palette.KenColors.ClientBlack2,
    fontSize: '16px !important',
    fontWeight: '500 !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  eventDetailsTypo2: {
    color: theme.palette.KenColors.ClientBlack,
    fontSize: '14px !important',
    fontWeight: '600 !important',
    lineHeight: '23px',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
    '@media (min-width: 1440px) and (max-width: 1460px)': {
      fontSize: '12px !important',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      fontSize: '16px !important',
    },
  },
  networkImg: {
    height: '10px',
    width: '10px',
    [theme.breakpoints.up('xxl')]: {
      height: '58.5px',
      width: '58.5px',
    },
  },
  detailsBox: {
    marginTop: '0px !important',
    height: '44vh',
  },
  cardContainer: {
    // Mobile styles (default)
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '16px',
    width: '100%',
    overflow: 'hidden',
    padding: '8px 0',
      // height: 'calc(100vh - 143px)',

    '& > *': {
      width: '100%',
      maxWidth: '100%'
    },

    // Desktop styles
    [theme.breakpoints.up('md')]: {
      background: theme.palette.KenColors?.kenWhite || '#ffffff',
      boxShadow: 'none !important',
      height: 'calc(100vh - 143px)',
      overflowY : 'scroll',
      borderRadius: '9px !important',
      display: 'block', // Override grid for desktop
      padding: '0', // Reset padding for desktop
    }
  },

  cardContainer1: {
    // Mobile styles (default)
    backgroundColor: "white",
    borderRadius: "9px",
    padding: "15px",
    overflow: "hidden",

    // Desktop styles
    [theme.breakpoints.up('md')]: {
      background: theme.palette.KenColors?.kenWhite || '#ffffff',
      padding: '18px',
      boxShadow: 'none !important',
      // height: '84vh !important',
      borderRadius: '9px !important',

      minHeight: 'unset', // Override mobile minHeight
    }
  },

  cardContainer2: {
    // Mobile styles (default)
    backgroundColor: "white",
    borderRadius: "9px",
    padding: "0px",
    height: "auto",
    maxHeight: "80vh",
    overflow: "auto",

    // Desktop styles
    [theme.breakpoints.up('md')]: {
      background: theme.palette.KenColors?.kenWhite || '#ffffff',
      padding: '18px',
      boxShadow: 'none !important',
      borderRadius: '9px !important',
      height: '72vh !important',
      maxHeight: 'unset', // Override mobile maxHeight
      top: "20%",

      // Large desktop styles
      '@media (min-width: 1440px) and (max-width: 1460px)': {
        top: "22%",
        height: '66vh !important',
      }
    }
  },

  ShowcaseYourBusiness: {
    backgroundColor: "#EAEFFF",
    borderRadius: "9px",
    padding: "15px",
    height: "auto",
    minHeight: "200px",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",

    [theme.breakpoints.up('md')]: {
      backgroundImage: "linear-gradient(to right, #FAB400, #FFE090)",
      backgroundColor: "transparent", 
      padding: "20px",
      height: '32vh',
      minHeight: 'unset',
      textAlign: "start",
      color: "#5B4200",
      marginTop: "15px",
      display: "none"
    }
  },

  mobileOnly: {
    [theme.breakpoints.up('md')]: {
      display: 'none !important'
    }
  },

  desktopOnly: {
    [theme.breakpoints.down('md')]: {
      display: 'none !important'
    }
  },

  // Scrollbar styling
  'scrollbar-cusgray': {
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
      borderRadius: '3px',
      '&:hover': {
        background: '#a8a8a8',
      },
    },
  },

  filterModal: {
    position: "absolute",
    right: "23%",
    backgroundColor: "white",
    padding: "0px",
    width: "360px",
    zIndex: "1",
    border: "1px solid #E4E4E7",
    borderRadius: "12px",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
    overflowY: "scroll",

    // Mobile responsive positioning
    [theme.breakpoints.down('md')]: {
      right: "5%",
      width: "90vw",
      maxWidth: "320px",
    },

    [theme.breakpoints.down('sm')]: {
      right: "2.5%",
      width: "95vw",
      maxWidth: "300px",
    }
  },

  // New: Mobile-specific filter modal style
  filterModalMobile: {
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      left: 0,
      right: 0,
      bottom: 0,
      top: 'auto',
      width: '100vw',
      maxWidth: '100vw',
      borderRadius: '16px 16px 0 0',
      zIndex: 1300,
      boxShadow: '0px -2px 20px rgba(0,0,0,0.12)',
      border: 'none',
      padding: 0,
      margin: 0,
      background: '#fff',
      overflowY: 'auto',
      minHeight: '40vh',
      height: 'auto',
      animation: '$slideUp 0.3s',
    },
  },
  '@keyframes slideUp': {
    '0%': { transform: 'translateY(100%)' },
    '100%': { transform: 'translateY(0)' },
  },
}));
